<template>
  <b-sidebar
    id="order-movement-details-history"
    ref="modal"
    header-class="headerModalToggle"
    right
    shadow
    size="l"
    width="60%"
    :title="$t('OrderMovementDetails')"
    @hidden="onCancelToggle"
  >
    <template #title>
      <strong style="color: #101828;">{{ $t('OrderMovementDetails') }}: {{ getOrderMovementDetails?.orderMovementNumber }}, {{ $t(orderMovementState) }}</strong>
    </template>
    <template
      v-slot:header-close
    >
      <button
        style="color: #98A2B3;padding-left: 0px; padding-right: 0px;height: 60px;"
        class="fa fa-close"
        @click="onCancelToggle"
      />
    </template>
    <div style="padding:20px;">
      <LoadingWrapperSpinner
        request-id="loadOrderMovementDetails"
        class="display-elements"
      >
        <b-form-group
          :label="$t('deliverStoreName')"
        >
          <b-form-input
            v-model="deliverStoreName"
            disabled
            style="padding:0.375rem 0.75rem;"
          />
        </b-form-group>
        <b-form-group
          :label="$t('receiverStoreName')"
        >
          <b-form-input
            v-model="receiverStoreName"
            disabled
            style="padding:0.375rem 0.75rem;"
          />
        </b-form-group>
        <b-form-group
          :label="$t('ResponsibleUser')"
        >
          <b-form-input
            v-model="responsibleUser"
            disabled
            style="padding:0.375rem 0.75rem;"
          />
        </b-form-group>
        <b-form-group
          :label="$t('deliverDate')"
        >
          <b-form-input
            v-model="deliveryDate"
            disabled
            style="padding:0.375rem 0.75rem;"
          />
        </b-form-group>
        <div
          class="dropdown-item-span"
          style="align-items:flex-end;"
        >
          <img
            style="cursor:pointer;width:30px;height:30px;"
            src="../../../assets/images/pdf-invoice-logo.svg"
            @click="downloadPDF(clickedOrderMovementId)"
          >
        </div>
      </LoadingWrapperSpinner>
      <div
        style="margin-top:10px;"
        class="table-elements"
      >
        <h4>
          {{ $t('Orders') }}
        </h4>
        <table
          class="team_table"
        >
          <thead>
            <tr>
              <th>
                {{ $t('No') }}
              </th>
              <th>
                {{ $t('OrderNumber') }}
              </th>
              <th>
                {{ $t('ArticleNumber') }}
              </th>
              <th>
                {{ $t('State') }}
              </th>
            </tr>
          </thead>
          <LoadingSpinnerTable
            :is-loading="isRequestLoading('loadOrderMovementDetails')"
            :response-data="getOrderMovementDetails?.lineItemMovementPendingResponseDtos || []"
          >
            <tr
              v-for="(article, index) in getOrderMovementDetails?.lineItemMovementPendingResponseDtos"
              :key="index"
            >
              <td>
                {{ index + 1 }}
              </td>
              <td>
                {{ article.orderNumber }}
              </td>
              <td>
                {{ article.articleNumber }}
              </td>
              <td>
                {{ $t(article.state) || $t('NotAccepted') }}
              </td>
            </tr>
          </LoadingSpinnerTable>
        </table>
      </div>
      <div
        style="margin-top:10px;"
        class="table-elements"
      >
        <h4>
          {{ $t('Articles') }}
        </h4>
        <table
          class="team_table"
        >
          <thead>
            <tr>
              <th>
                {{ $t('No') }}
              </th>
              <th>
                {{ $t('Barcode') }}
              </th>
              <th>
                {{ $t('ArticleNumber') }}
              </th>
              <th>
                {{ $t('Amount') }}
              </th>
              <th>
                {{ $t('State') }}
              </th>
            </tr>
          </thead>
          <LoadingSpinnerTable
            :is-loading="isRequestLoading('loadOrderMovementDetails')"
            :response-data="getOrderMovementDetails?.productInStockMovementPendingResponseDtos || []"
          >
            <tr
              v-for="(article, index) in getOrderMovementDetails?.productInStockMovementPendingResponseDtos"
              :key="index"
            >
              <td>
                {{ index + 1 }}
              </td>
              <td>
                {{ article.barcode || $t('NoBarcode') }}
              </td>
              <td>
                {{ article.articleNumber }}
              </td>
              <td>
                {{ article.amount }}
              </td>
              <td>
                {{ $t(article.state) || $t('NotAccepted') }}
              </td>
            </tr>
          </LoadingSpinnerTable>
        </table>
      </div>
      <div
        v-if="isDownloadingPDF"
        style="width:100%"
        class="pdf-spinner-overlay"
      >
        <span class="loader" />
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import jsPDF from 'jspdf';
import {
  xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo,
} from '../../iconsImageUsers';
import 'jspdf-autotable';



export default {
  components: {
  },
  props: ['orderMovementState', 'clickedOrderMovementId'],
  data() {
    return {
      responsibleUser: '',
      receiverStoreName: null,
      deliverStoreName: null,
      deliveryDate: null,
      isDownloadingPDF: false,
    };
  },
  computed: {
    ...mapGetters(['getOrderMovementDetails', 'getOrderMovementDetailsPDF', 'getAllStoresDropdown', 'getUsersByMultipleRoles']),
    filteredStoresDeliverer() {
      const filteredStores = this.getAllStoresDropdown.filter((store) => {
        return store.storeName !== 'all' && store.storeName !== 'unassigned';
      });

      const updatedStores = filteredStores.map((store) => {
        return {
          ...store,
          deliverStoreName: store.storeName,
        }
      });

      const allOption = { storeId: null, deliverStoreName: 'No store', storeGLN: null };
      return [allOption, ...updatedStores];
    },
    filteredStoresReceiver() {
      const filteredStores = this.getAllStoresDropdown.filter((store) => {
        return store.storeName !== 'all' && store.storeName !== 'unassigned';
      });

      const updatedStores = filteredStores.map((store) => {
        return {
          ...store,
          receiverStoreName: store.storeName,
        }
      });

      const allOption = { storeId: null, receiverStoreName: 'No store', storeGLN: null };
      return [allOption, ...updatedStores];
    },
  },
  watch: {
    getOrderMovementDetails: {
      handler(newVal) {
        if (newVal) {
          this.responsibleUser = newVal.userFullName || this.$t('NoResponsibleUserFound');
          this.receiverStoreName = newVal.receiverStoreName || this.$t('NoReceiverStoreName');
          this.deliverStoreName = newVal.deliverStoreName || this.$t('NoDeliverStoreName');
          this.deliveryDate = moment(newVal.deliveryDate).format('YYYY-MM-DD') || this.$t('NoDeliveryDate');
        }
      },
      immediate: true,
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions(['loadOrderMovementDetails', 'loadOrderMovementDetailsPDF']),
    onCancelToggle() {
      this.$emit('onCancelToggle');
      this.$refs.modal.hide();
    },
    async downloadPDF(value) {
      this.isDownloadingPDF = true;

      try {
        await this.loadOrderMovementDetailsPDF({
          orderMovementId: value,
        });

        const tableContent = this.generateLineItemsTablePDF(this.getOrderMovementDetailsPDF?.lineItemMovementPendingResponseDtos);
        const tableContent2 = this.generateProductsInStockTablePDF(this.getOrderMovementDetailsPDF?.productInStockMovementPendingResponseDtos);
        const pdfDocument = this.generatePDF(tableContent, tableContent2, xharraIcon, iconLogo, qrCodeLogo, facebookLogo, instaLogo, mailLogo, 800);

        pdfDocument.save(`${this.$t('orderMovementNumber')}: ${this.getOrderMovementDetailsPDF?.orderMovementNumber}-${moment().format('DD/MM/YYYY - hh:mm:s')}.pdf`);
      } catch (error) {
        console.error('Error downloading the data:', error);
      } finally {
        this.isDownloadingPDF = false;
      }
    },
    generateProductsInStockTablePDF(items) {
      const headers1 = [
        `${this.$t('No.')}`,
        `${this.$t('ArticleNumber')}`,
        `${this.$t('Barcode')}`,
        `${this.$t('Amount')}`,
        `${this.$t('State')}`,
      ];

      let body1 = [];

      if (!items || items.length === 0) {
        body1 = [[
          1,
          '—',
          '—',
          '—',
        ]];
      } else {
        body1 = items.map((item, index) => {
          return [
            index + 1,
            item.articleNumber,
            item.barcode || this.$t('NoBarcode'),
            item.amount || 0,
            this.$t(item.state) || this.$t('NotAccepted'),
          ];
        });
      }

      return {
        headers1,
        body1,
      };
    },
    generateLineItemsTablePDF(items) {
      const headers = [
        `${this.$t('No.')}`,
        `${this.$t('OrderNumber')}`,
        `${this.$t('ArticleNumber')}`,
        `${this.$t('State')}`,
      ];

      let body = [];

      if (!items || items.length === 0) {
        body = [[
          1,
          '—',
          '—',
        ]];
      } else {
        body = items.map((item, index) => {
          return [
            index + 1,
            item.orderNumber,
            item.articleNumber,
            this.$t(item.state) || this.$t('NotAccepted'),
          ];
        });
      }

      return {
        headers,
        body,
      };
    },
    generatePDF(tableContent, tableContent2, firstIcon, secondIcon, thirdIcon, fourthIcon, fifthIcon, sixthIcon, customWidth) {
      const { headers, body } = tableContent;
      const { headers1, body1 } = tableContent2;

      // eslint-disable-next-line new-cap
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'pt',
        format: [750, 900],
      });

      // Set custom width after creating the doc instance
      doc.setProperties({
        format: [customWidth, doc.internal.pageSize.getHeight()],
      });

      const firstText = `${this.$t('State')} : ${this.$t(this.orderMovementState)}`;
      const firstTextX = 40;
      const firstTextY = 90;
      doc.setFontSize(15);
      doc.setFont('Helvetica', 'normal');
      doc.setTextColor(0, 0, 0);
      doc.text(firstText, firstTextX, firstTextY, { align: 'left' });

      const inlineGap = 35;

      const secondText = `${this.$t('deliverDate')} : ${moment(this.getOrderMovementDetailsPDF?.deliverDate).format('YYYY-MM-DD')}`;
      const secondTextX = firstTextX + doc.getTextWidth(firstText) + inlineGap;
      doc.text(secondText, secondTextX, firstTextY, { align: 'left' });

      const verticalGap = 25;

      const thirdText = `${this.$t('deliverStoreName')} : ${this.getOrderMovementDetails?.deliverStoreName}`;
      const thirdTextX = firstTextX;
      const thirdTextY = firstTextY + verticalGap;
      doc.text(thirdText, thirdTextX, thirdTextY, { align: 'left' });

      // Calculate width of thirdText
      const thirdTextWidth = doc.getTextWidth(thirdText);
      const receiverGap = 20;

      const fourthText = `${this.$t('receiverStoreName')} : ${this.getOrderMovementDetails?.receiverStoreName}`;
      // Place fourthText after thirdText + gap
      const fourthTextX = thirdTextX + thirdTextWidth + receiverGap;
      const fourthTextY = thirdTextY;
      doc.text(fourthText, fourthTextX, fourthTextY, { align: 'left' });

      const staticContent = () => {
        const title = `${this.$t('orderMovementNumber')} : ${this.getOrderMovementDetailsPDF?.orderMovementNumber}`;
        const titleY = 50;
        const titleX = 40;
        doc.setFontSize(30);
        doc.setFont('Helvetica', 'normal');
        doc.setTextColor(0, 0, 0);
        doc.text(title, titleX, titleY, { align: 'left' });

        const iconWidth = 150;
        const iconHeight = 100;
        const iconY = 5;
        const iconX = doc.internal.pageSize.getWidth() - 180;
        doc.addImage(firstIcon, 'PNG', iconX, iconY, iconWidth, iconHeight);

        // Location and Phone details
        const locations = [
          { name: 'PRISHTINË - Çagllavicë', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
          { name: 'GJILAN', name2: 'Përball FSK-së', phone: '+383 44 991 994' },
          { name: 'PRIZREN', name2: 'Lubizhdë - Km. 1', phone: '+383 43 778 778' },
          { name: 'FERIZAJ - Magj.', name2: 'Ferizaj-Prishtinë - Km. 1', phone: '+383 49 640 940' },
          { name: 'PRISHTINË 2', name2: 'Rrethi Marigona Residence', phone: '+383 44 503 399' },
        ];

        const locationsY = doc.internal.pageSize.getHeight() - 90; // Start just above the footer
        const locationSpacing = 132; // Space between each location block

        const startXPosition = 40; // Starting position for the first location
        const endXPosition = startXPosition + (locations.length - 1) * locationSpacing + 132; // End X position based on number of locations

        // Loop through the locations array and display each one
        locations.forEach((location, index) => {
          const xPosition = 40 + index * locationSpacing; // Adjust X position for each location
          doc.setFontSize(8);
          doc.setTextColor(0, 0, 0); // Black color

          // Add the location icon
          const iconXPosition = xPosition - 25; // Position the icon just before the location name
          const iconYPosition = locationsY - 10; // Position the icon just above the location name
          doc.addImage(secondIcon, 'PNG', iconXPosition, iconYPosition, 28, 29); // Icon size 10x10 (adjust as needed)

          // Display the location name
          doc.text(location.name, xPosition, locationsY);

          doc.text(location.name2, xPosition, locationsY + 15);

          // Display the phone number below the location name
          doc.text(location.phone, xPosition, locationsY + 30); // Position phone number below the location name
        });

        // Add a line under the locations block, spanning the width of the locations
        doc.setDrawColor(0, 0, 0); // Black color for the line
        const lineY = locationsY + 40; // Position the line just below the last location's phone number
        doc.line(startXPosition, lineY, endXPosition, lineY); // Draw a line across the width of the locations

        // Show the three items in a row below the line
        const itemsXStart = 40; // Starting position for the row of items
        const itemsY = lineY + 3; // Y-position for the items row

        const items = [
          { icon: fourthIcon, text: 'NOTAbrillantOfficial' },
          { icon: fifthIcon, text: 'nota.brillant' },
          { icon: sixthIcon, text: 'info@notabrillantofficial.com' },
        ];

        // Space between each item in the row
        const itemSpacing = 150; // Adjust this for the space between icons and text

        items.forEach((item, index) => {
          const xPosition = itemsXStart + index * itemSpacing; // Calculate horizontal position for each item

          // Add the icon and text next to each other
          doc.addImage(item.icon, 'PNG', xPosition, itemsY, 20, 20); // Icon position and size
          doc.setFontSize(12);
          doc.text(item.text, xPosition + 25, itemsY + 15); // Position text next to the icon (adjust the X offset if needed)
        });

        // QR code section
        const qrCodeText = 'Blej online';
        const qrCodeTextWidth = doc.getTextWidth(qrCodeText);
        const qrCodeTextX = 680 + (45 - qrCodeTextWidth) / 2; // Center the text above the QR code
        const qrCodeTextY = doc.internal.pageSize.getHeight() - 60; // Adjust the Y position to place text above the QR code
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0); // Black color
        doc.text(qrCodeText, qrCodeTextX, qrCodeTextY);

        // Add the QR code image
        doc.addImage(thirdIcon, 'PNG', 680, doc.internal.pageSize.getHeight() - 50, 45, 45);

        // Footer section
        const footerText = 'Powered by DigIT';
        const footerTextWidth = doc.getTextWidth(footerText);
        const centerX = (doc.internal.pageSize.getWidth() - footerTextWidth) / 2;
        const footerY = doc.internal.pageSize.getHeight() - 10;

        doc.setFontSize(10);
        doc.setTextColor(160, 160, 160);
        doc.text(footerText, centerX, footerY);
      };

      const tableLeftMargin = 40;

      // Add header "Orders" before the first table
      doc.setFontSize(16); // Adjust the font size for the header
      doc.text(this.$t('Orders'), tableLeftMargin, 150);
      doc.autoTable({
        startY: 160,
        head: [headers],
        body,
        headStyles: {
          fillColor: [249, 249, 249],
          textColor: [96, 96, 96],
          lineColor: [181, 181, 181],
          lineWidth: 0.1,
          halign: 'left',
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          lineWidth: 0.1,
        },
        pageBreak: 'auto',
        columnStyles: {
          0: { columnWidth: doc.internal.pageSize.getWidth() / 20, halign: 'left', fillColor: [255, 255, 255] },
          1: { columnWidth: doc.internal.pageSize.getWidth() / 3.5, halign: 'left', fillColor: [255, 255, 255] },
          2: { columnWidth: doc.internal.pageSize.getWidth() / 3.5, halign: 'left', fillColor: [255, 255, 255] },
          3: { columnWidth: doc.internal.pageSize.getWidth() / 3.5, halign: 'left', fillColor: [255, 255, 255] },
        },
        afterPageContent: staticContent,
      });

      const firstTableEndY = doc.lastAutoTable.finalY;

      // Add header "Products" before the second table
      doc.setFontSize(16); // Adjust font size for the second header
      doc.text(this.$t('Products'), tableLeftMargin, firstTableEndY + 20);

      const secondTableStartY = firstTableEndY + 30; // Where the second table will start

      // Check available space for the second table
      const availableSpace = doc.internal.pageSize.getHeight() - secondTableStartY - 20; // 20 for margin

      // If the available space is less than the second table's height, add a page break
      if (availableSpace < 150) { // Assuming the second table is around 150pt high
        doc.addPage();
        doc.setFontSize(16); // Header for the second table again
        doc.text(this.$t('Products'), tableLeftMargin, 40); // Start the second table header at the top of the page
      }

      // Start the second table at Y position 250 if it's on the second page
      const secondTableStartYPosition = doc.internal.getNumberOfPages() > 1 ? 250 : secondTableStartY;

      doc.autoTable({
        startY: secondTableStartYPosition,
        head: [headers1],
        body: body1,
        headStyles: {
          fillColor: [249, 249, 249],
          textColor: [96, 96, 96],
          lineColor: [181, 181, 181],
          lineWidth: 0.1,
          halign: 'left',
        },
        bodyStyles: {
          textColor: [0, 0, 0],
          lineWidth: 0.1,
        },
        pageBreak: 'auto',
        columnStyles: {
          0: { columnWidth: doc.internal.pageSize.getWidth() / 20, halign: 'left', fillColor: [255, 255, 255] },
          1: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
          2: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
          3: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
          4: { columnWidth: doc.internal.pageSize.getWidth() / 4.5, halign: 'left', fillColor: [255, 255, 255] },
        },
        afterPageContent: staticContent,
      });

      return doc;
    },
  },
};
</script>

  <style scoped>
  .pdf-spinner-overlay {
    width: 100%;
}
      .display-elements {
          border: 1px solid lightgrey;
          border-radius:12px;
          padding: 10px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 5px;
      }
      .table-elements {
          border: 1px solid lightgrey;
          border-radius:12px;
          padding: 10px;

      }
  </style>
